module.exports = __webpack_public_path__ + "static/media/eye-invisible-icon.fac61889.svg";